import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { useRetryableSrc } from '@/lib/image';

interface SnapshotPreviewProps {
  src: string;
  alt?: string;
}

export function SnapshotPreview({ src, alt }: SnapshotPreviewProps) {
  const [isLoaded, setIsLoaded] = useState(false);
  const retrySrc = useRetryableSrc(src);

  return (
    <div className="relative aspect-video w-full bg-black/40">
      <div
        className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${isLoaded ? 'opacity-0' : 'opacity-100'}`}
      >
        <Loader2 className="h-8 w-8 animate-spin text-gray-500" />
      </div>
      <img
        {...retrySrc}
        className={`h-full w-full object-contain transition-opacity duration-300 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}
        alt={alt || 'Alert snapshot'}
        loading="lazy"
        decoding="async"
        onLoad={() => setIsLoaded(true)}
      />
    </div>
  );
}
